export default {
  namespaced: true,
  state: {
    turbineCheckedList: [],
    isCompare: false,
    turbineList: [],
    currentTurbine: {},
    uploadSuccess: false,
    compareButtonLoading: false,
    turType: '0'
  },
  getters: {},
  action: {},
  mutations: {
    // 当前点击的机型
    CURRENT_TURBINE(state, payload) {
      state.currentTurbine = payload;
    },
    // 当前选中的机型
    TURBINE_CHECKED_LIST(state, payload) {
      state.turbineCheckedList = payload;
    },
    COMPARE_BUTTON(state, payload) {
      state.isCompare = payload;
    },
    COMPARE_BUTTON_LOADING(state, payload) {
      state.compareButtonLoading = payload;
    },
    TURBINE_LIST(state, payload) {
      state.turbineList = payload;
    },
    // 上传成功
    UPLOAD_SUCCESS(state, payload) {
      state.uploadSuccess = payload;
    },
    // 不用的机型列表
    TUR_TYPE(state, payload) {
      state.turType = payload;
    }
  }
};
